<template>
  <gj-modal
      :visible.sync="modalVisible"
      @cancel="cancel"
      @confirm="confirm"
      size="full-middle"
      @open="modalOpen"
      :contentStyle="{'height': '100%', display: 'flex', 'flex-direction': 'column'}"
  >
    <template #header>添加产品</template>
    <template #content>
      <div style="margin-bottom: 12px">
        <gj-select-input
            v-model="keyword"
            :options="[
              {id: 'sku', text: 'SKU'},
              {id: 'productName', text: '产品名称'},
            ]"
            @input="debounceQuery"
        ></gj-select-input>
      </div>
      <div style="flex: 1; overflow: auto;">
        <gj-table
            ref="gjTable"
            :index="false"
            :columns="columns"
            :data="data"
            :offset-height="62"
            :pagination="pagination"
            adapt-parent
            :loading="loading"
            selection
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery"
        >
          <template v-slot:productInfo="{row}">
            <div>
              <gj-text width="100%" :content="row.productName">{{ row.productName }}</gj-text>
            </div>
            <div>
              <gj-text width="100%" :content="row.sku">{{ row.sku }}</gj-text>
            </div>
          </template>
        </gj-table>
      </div>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn, queryMixin, selectionMixin} from "@/minxins";
import {getCanCheckProductPage} from "@/api/warehouse";
import {ProductEnum} from "@/utils/options";

export default {
  name: "app-inventory-add-product",
  mixins: [modalMixIn, selectionMixin, queryMixin],
  props: {
    warehouseId: null,
    hideSkuList: null,
  },
  data() {
    return {
      columns: [
        {id: 'img', header: '图片', field: 'picture:skuImageUrl', minWidth: '50px'},
        {id: 'productInfo', header: '产品名称/SKU', field: 'slot:productInfo', minWidth: '200px'},
        {
          id: 'productType',
          header: '产品类型',
          field: 'option:productType',
          minWidth: '100px',
          options: ProductEnum.typeOption
        },
        {id: 'goodProduct', header: '库存良品量', field: 'fulfillableQuantity', minWidth: '100px', align: 'right'},
        {id: 'defective', header: '库存次品量', field: 'unsellableQuantity', minWidth: '100px', align: 'right'},
      ],
      data: [],
      keyword: {
        key: 'sku',
        value: null,
      },
      debounceQuery: this._.debounce(this.$gjNoticeQuery, 500),
    }
  },
  methods: {
    $gjQuery() {
      this.sort.prop = 'sku';
      this.loading = true;
      const params = {
        model: {
          hideSkuList: this.hideSkuList,
          warehouseId: this.warehouseId,
        }
      };
      params.model[this.keyword.key] = this.keyword.value;
      getCanCheckProductPage({
        ...params,
        ...this.querySort,
        ...this.queryPagination,
      }).then((data) => {
        this.data = data.records;
        this.pagination = this.getPagination(data);
      }).complete(() => this.loading = false)
    },
    confirm() {
      this.$emit('addConfirm', this.selectedRows || [])
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding-bottom: 0;
}
</style>
